import { render } from "./CopyButton.vue?vue&type=template&id=ef93c098&scoped=true"
import script from "./CopyButton.vue?vue&type=script&lang=js"
export * from "./CopyButton.vue?vue&type=script&lang=js"

import "./CopyButton.vue?vue&type=style&index=0&id=ef93c098&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ef93c098"

export default script